// import type { ExtraParam } from 'plugins/HumanQaThreeRemarkInSession/src'
// 焦内客户的
const jiaonei_human_qa_three_remark_in_session_data: any = {
  data: {
    industry: {
      活动优惠: [
        '店铺活动',
        '优惠咨询',
        '赠品咨询',
        '差价咨询',
        '直播咨询',
        '会员服务',
        '预售相关',
        '首单礼金',
        '购物金咨询',
        '中奖咨询',
        '红包咨询',
      ],
      购买操作: ['订单备注/修改', '下单咨询', '运费险', '付款咨询', '发票咨询', '订单评价'],
      商品咨询: ['商品参数咨询', '商品推荐', '商品库存', '商品包装/自选', '商品使用/养护'],
      发货咨询: ['发货周期', '超期发货', '指定快递', '未超期催发货', '仓库咨询', '配送方式'],
      物流咨询: [
        '物流时效',
        '修改地址',
        '物流拦截',
        '中转错误',
        '走件异常',
        '送货上门',
        '已签非签',
        '派件异常',
        '拒收退回',
        '快递丢件',
        '超区无点',
        '物流正常催件',
      ],
      售后咨询: [
        '退货咨询',
        '换货咨询',
        '退款咨询',
        '错寄/转寄',
        '质量问题',
        '退差价',
        '退换货运费',
        '重发补发咨询',
        '错漏发相关',
        '体感问题',
        '购物金退款',
        '非质量问题售后',
        '包装相关',
        '收货敏感问题',
        '发票问题',
      ],
      投诉类: ['客服投诉', '投诉与建议', '物流投诉'],
    },
    cause: {
      服务能力: ['主动服务意识弱', '用词不当', '机械应答', '未同理心安抚'],
      业务能力: ['业务流程不熟悉', '产品不熟悉', '活动不熟悉', '系统操作错误'],
      服务红线: ['过度承诺', '辱骂客户', '反问反怼'],
      服务态度: ['未回复', '推诿', '服务冷漠'],
      用户问题: [
        '用户诉求不合理',
        '（疑似）点错评价',
        '正常时效催回复，人工未响应',
        '客服表述正确但用户不理解',
        '无故差评',
      ],
      流程问题: [
        '用户诉求合理，当前流程不支持',
        '不满物流问题处理时效',
        '不满退换审核时效',
        '不满换货发出时效',
        '不满售后异常',
        '不满售后退款时效',
        '不满内裤不支持7无',
        '不满套装产品不支持部分退货',
        '不满售后方案',
      ],
      产品问题: [
        '产品质量差',
        '无客户尺码',
        '产品不支持自选',
        '产品缺货',
        '产品价格贵',
        '产品信息缺失',
        '产品包装',
      ],
      机器人问题: ['话术太官方', '答非所问'],
      运营问题: ['天机系统商品配置错误', '商品详情信息配置错误'],
      快递问题: ['快递时效慢', '无法修改地址', '未送货上门', '超区无点'],
      仓库问题: ['仓库错漏发', '包装破损'],
      活动问题: [
        '不满大促繁忙回复慢',
        '不满产品降价',
        '不满不支持订单修改（尺码/颜色）',
        '不满活动规则',
      ],
      发货问题: ['不满发货时效', '不满配送方式'],
      营销问题: ['不满营销信息骚扰（店铺信息）', '不满营销短信骚扰'],
      平台问题: ['系统异常', '不满平台活动', '下单异常'],
      非业务咨询: ['合作咨询', '代言人问题'],
      其他: ['其他'],
    },
    text: ['日常抽检', '不满意专项', '新人专项', '转接专项'],
  },
  render: {
    remarkComponents: [
      {
        indexName: '质检类型',
        indexType: 2,
        formName: 'text',
        dataKey: 'text',
        hackProps: {
          placeholder: '请选择备注的质检类型',
        },
        hitPointKey: 'dialog',
      },
      {
        indexName: '问题分类',
        indexType: 1,
        formName: 'industry',
        dataKey: 'industry',
        hackProps: {
          placeholder: '一级分类 / 二级分类',
        },
        hitPointKey: 'dialog',
      },
      {
        indexName: '问题根因',
        indexType: 1,
        formName: 'cause',
        dataKey: 'cause',
        hackProps: {
          placeholder: '一级根因 / 二级根因',
        },
        hitPointKey: 'dialog',
      },
    ],
    usePositions: ['blowCheckType', 'blowInputSearch'],
    useDataKeys: ['industry', 'cause', 'text'],
    combineStateRule: {
      industry: {
        resultNameSuffix: '分类',
        resultNameUnit: '级',
      },
      cause: {
        resultNameSuffix: '根因',
        resultNameUnit: '级',
      },
      text: {
        resultName: '质检类型',
      },
    },
  },
  table: {
    columnsOrderStart: 4,
    columns: [
      { title: '质检类型（备注）', resultName: '质检类型' },
      { title: '一级分类' },
      { title: '二级分类' },
      { title: '一级根因' },
      { title: '二级根因' },
    ],
  },
}
// 青岛蓝色基点电子商务有限公司
const lanse_human_qa_three_remark_in_session_data: ExtraParam = {
  data: {},
  render: {
    remarkComponents: [
      {
        indexName: '客服自评备注',
        indexType: 0,
        formName: 'self_comment_mark',
        hackProps: {
          placeholder: '请输入存在的问题点和待改进措施',
          maxLength: 200,
          rows: 4,
        },
        hitPointKey: 'dialog',
      },
      {
        indexName: '组长复核备注',
        indexType: 0,
        formName: 'recheck_mark',
        hackProps: {
          placeholder: '请对客服的自评进行检查,给出待改进点,和具体的改善思路',
          maxLength: 200,
          rows: 4,
        },
        hitPointKey: 'dialog',
      },
      {
        indexName: '客服确认备注',
        indexType: 0,
        formName: 'verify_mark',
        hackProps: {
          placeholder: '请对组长的回复进行确认,无误请回复【OK】。如果存在异议,请详细描述',
          maxLength: 200,
          rows: 4,
        },
        hitPointKey: 'dialog',
      },
      {
        indexName: '其他',
        indexType: 0,
        formName: 'other_mark',
        hitPointKey: 'dialog',
        hackProps: {
          maxLength: 200,
          rows: 4,
        },
      },
    ],
    useDataKeys: [],
    combineStateRule: {
      self_comment_mark: {
        resultName: '客服自评备注',
      },
      recheck_mark: {
        resultName: '组长复核备注',
      },
      verify_mark: {
        resultName: '客服确认备注',
      },
      other_mark: {
        resultName: '其他',
      },
    },
  },
  table: {
    columnsOrderStart: 4,
    columns: [
      { title: '客服自评备注' },
      { title: '组长复核备注' },
      { title: '客服确认备注' },
      { title: '其他' },
    ],
  },
}

export { jiaonei_human_qa_three_remark_in_session_data as human_qa_three_remark_in_session_data }
